import { createUseAppTranslation } from '@spendbrain/config/utils';

export const useAppTranslation = createUseAppTranslation('tickets');
